import { Badge } from "~/components/ui/badge";
import { Database } from "~/types/supabase";

type TotemStatus = Database["public"]["Enums"]["totem_status"];

interface TotemStatusBadgeProps {
  status: TotemStatus;
  size?: "sm" | "default";
}

const statusConfig: Record<
  TotemStatus,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline"; className: string }
> = {
  available: {
    label: "Disponible",
    variant: "default",
    className: "bg-green-500 hover:bg-green-600",
  },
  filled: {
    label: "Lleno",
    variant: "default",
    className: "bg-blue-500 hover:bg-blue-600",
  },
  in_transit: {
    label: "Uso Interno",
    variant: "default",
    className: "bg-cyan-500 hover:bg-cyan-600",
  },
  at_client: {
    label: "En Cliente",
    variant: "default",
    className: "bg-indigo-500 hover:bg-indigo-600",
  },
  pickup_ready: {
    label: "Listo Retiro",
    variant: "default",
    className: "bg-yellow-500 hover:bg-yellow-600 text-black",
  },
  pickup_scheduled: {
    label: "Retiro Prog.",
    variant: "default",
    className: "bg-orange-500 hover:bg-orange-600",
  },
  pickup_transit: {
    label: "En Retorno",
    variant: "default",
    className: "bg-teal-500 hover:bg-teal-600",
  },
  returned: {
    label: "Retornado",
    variant: "secondary",
    className: "bg-slate-400 hover:bg-slate-500",
  },
  cleaning: {
    label: "En Limpieza",
    variant: "default",
    className: "bg-purple-500 hover:bg-purple-600",
  },
  damaged: {
    label: "Dañado",
    variant: "destructive",
    className: "",
  },
  lost: {
    label: "Perdido",
    variant: "destructive",
    className: "bg-gray-700 hover:bg-gray-800",
  },
};

export function TotemStatusBadge({ status, size = "default" }: TotemStatusBadgeProps) {
  const config = statusConfig[status] || {
    label: status,
    variant: "outline" as const,
    className: "",
  };

  return (
    <Badge
      variant={config.variant}
      className={`${config.className} ${size === "sm" ? "text-xs px-1.5 py-0" : ""}`}
    >
      {config.label}
    </Badge>
  );
}

export function getStatusLabel(status: TotemStatus): string {
  return statusConfig[status]?.label || status;
}
